var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('TopHeader'),_c('mainContent'),_c('LayoutFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }